// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"686":"3f3032a6","7550":"77919920","8208":"925a2f5f"}[chunkId] + ".chunk.css";
};